var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrialBalance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E5F0EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.787 23.233a1 1 0 0 0-1.224.707l-5.694 21.25a1 1 0 0 0 .707 1.225l38.637 10.352a1 1 0 0 0 1.224-.707l5.695-21.25a1 1 0 0 0-.708-1.225L22.787 23.233Zm23.94 18.838a8 8 0 1 1-15.454-4.142 8 8 0 0 1 15.454 4.142Z",
    fill: "#006C52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 28a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h40a1 1 0 0 0 1-1V29a1 1 0 0 0-1-1H19Zm28 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8 4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    fill: "#006C52"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrialBalance);
export default __webpack_public_path__ + "static/media/trial-balance.ec9a06ed.svg";
export { ForwardRef as ReactComponent };